import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { useAuth, homeFor } from "../lib/auth";
import { apiError } from "../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to={homeFor(user.role)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      nav(homeFor(u.role));
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="grid min-h-[75vh] place-items-center bg-[var(--paper)] px-5 py-16">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md rounded-[28px] bg-white p-8 ring-1 ring-black/5 md:p-10">
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[var(--forest)] text-[var(--lime)]"><Lock className="h-5 w-5" /></span>
        <h1 className="mt-6 font-display text-4xl">Panel privado</h1>
        <p className="mt-2 text-sm text-[var(--muted-ink)]">Administración, boleterías y conductores.</p>
        <div className="mt-6 space-y-3">
          <Input data-testid="admin-email-input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-12 rounded-xl" />
          <Input data-testid="admin-password-input" type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-12 rounded-xl" />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-3 text-sm font-medium text-red-700">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="mt-5 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white hover:bg-[var(--forest-2)]">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Ingresar
        </button>
      </form>
    </section>
  );
}
